import { getToken } from "services/auth/tokenAuth";
import doRequest from "services/helpers";

export async function requestGetResourceTypes() {
    const [result, err] = await doRequest(
        "/Recurso/ListarServiciosPrestamo", "GET", 
        null, getToken());
    if (err)
        return null;
    const { data } = result;
    if (data?.state !== 1)
        return null;
    return data.data.listServicioPrestamo
        .map(({
            idServicioPrestamo, nombre
        }) => ({
            id: idServicioPrestamo,
            name: nombre
        }));
}

export async function requestGetElectronicBrands() {
    const [result, err] = await doRequest(
        "/Recurso/ListarMarcas", "GET", 
        null, getToken());
    if (err)
        return null;
    const { data } = result;
    if (data?.state !== 1)
        return null;
    return data.data?.listMarcas?.map(({
        idMarca, nombre,
        idServicioPrestamo
    }) => ({
        id: idMarca,
        name: nombre,
        resourceTypeId: idServicioPrestamo
    }));
}

export async function requestGetScreenList() {
    const [result, err] = await doRequest(
        "/Recurso/ListarPantallas", "GET", 
        null, getToken());
    if (err)
        return null;
    const { data } = result;
    if (data?.state !== 1)
        return null;
    return data.data?.listPantallas?.map(({
        idPantalla, nombre
    }) => ({
        id: idPantalla,
        name: nombre
    }));
}

export async function requestGetLibraries() {
    const [result, err] = await doRequest(
        "/Recurso/ListarBibliotecas", "GET", 
        null, getToken());
    if (err)
        return null;
    const { data } = result;
    if (data?.state !== 1)
        return null;
    return data.data?.bibliotecas.map(({
        idBiblioteca, nombre, idCampus
    }) => ({
        id: idBiblioteca,
        name: nombre,
        campusId: idCampus
    }));
}

export async function requestGetLibraryReasonsForPenalize() {
    const [result, err] = await doRequest(
        "/Recurso/ListarMotivoSancion", "GET", 
        null, getToken());
    if (err)
        return null;
    const { data } = result;
    if (data?.state !== 1)
        return null;
    return data.data?.motivoSancion.map(({
        idMotivoSancion, nombre, descripcion, 
        idServicioPrestamo, esPorDias
    }) => ({
        id: idMotivoSancion,
        name: nombre, description: descripcion,
        resourceTypeId: idServicioPrestamo,
        isForDays: esPorDias
    }));
}
